import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { AppLayout, Sidebar } from '../ds';
import { useAuth } from '../../context/AuthContext';

const IconAccounts = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="6" height="6" rx="1"/><rect x="11" y="3" width="6" height="6" rx="1"/>
    <rect x="3" y="11" width="6" height="6" rx="1"/><rect x="11" y="11" width="6" height="6" rx="1"/>
  </svg>
);

const IconTemplates = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="14" height="14" rx="2"/><path d="M7 7h6M7 10h4"/>
  </svg>
);

export default function Layout() {
  const { logout, user } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    try { await logout(); } catch (e) { /* ignore */ }
  };

  const sidebarContent = (
    <Sidebar logo="VMFIVE" subtitle="Ad SaaS Admin" footer={
      <div>
        {user && <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 8 }}>{user.userName}</div>}
        <button
          onClick={handleLogout}
          style={{
            width: '100%', padding: '6px 16px', background: 'none',
            border: '1px solid rgba(255,255,255,0.2)', color: '#fff',
            borderRadius: 4, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
          }}
        >
          Logout
        </button>
      </div>
    }>
      <Sidebar.Group title="Main">
        <NavLink to="/accounts" style={{ textDecoration: 'none' }}>
          {({ isActive }) => (
            <Sidebar.Item icon={<IconAccounts />} label="Accounts" active={isActive} />
          )}
        </NavLink>
        <NavLink to="/templates" style={{ textDecoration: 'none' }}>
          {({ isActive }) => (
            <Sidebar.Item icon={<IconTemplates />} label="Templates" active={isActive} />
          )}
        </NavLink>
      </Sidebar.Group>
    </Sidebar>
  );

  const pageTitle = location.pathname.startsWith('/accounts') ? 'Accounts'
    : location.pathname.startsWith('/templates') ? 'Templates'
    : '';

  return (
    <AppLayout
      sidebar={sidebarContent}
      header={<h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{pageTitle}</h2>}
    >
      <Outlet />
    </AppLayout>
  );
}
